
<template>
	<div
		class="basePage"
	>
		<TopBar></TopBar>
		<a id="afvalpunten" class="noRender" />
		<a id="meldingen" class="noRender" />
		<a id="heatmap" class="noRender" />
		<a id="kaartoverzicht" class="noRender" />

		<div v-if="hasHeader" class="basePage_header">
			<Header ref="header" :key="headerKey" :cfg="headerCfg" :logo-modifiers="logoModifiers">
				<template #headerActions>
					<slot name="headerActions" />
				</template>
			</Header>
			<GlobalMessageBox />
			<slot name="header" />
		</div>
		<div v-else>
			<GlobalMessageBox />
		</div>

		<div :style="[heightWrapperStyle]" class="heightWrapper">
			<div
				class="mainContent"
				:class="{ 'mainContent--overflow': overflowContent }"
			>
				<slot name="beforeInner" />
				<div v-if="wrapInner" class="mainContent-inner">
					<slot />
				</div>
				<slot name="withoutWrapper" />
			</div>
		</div>
		<Footer v-if="hasFooter" :large="largeFooter" ref="footer" />

		<div id="basicOverlays"></div>
		<div id="fractionEvolutions"></div>
		<div id="measureEdit"></div>
		<div id="measureApply"></div>
		<div id="projectDuplicate"></div>
		<div id="projectClose"></div>
		<div id="scanEdit"></div>
		<div id="projectComparison"></div>
		<div id="binMeasurementComparison"></div>

		<!-- gdpr overlay -->
		<span v-if="!session.gdprUser.acceptProTermsOfUse && authenticated">
			<GdprTermsOverlay ref="termsOverlay" @denyTerms="showDenyTerms" @approveGdpr="approveGdpr" :gdprUser="session.gdprUser"></GdprTermsOverlay>
			<GdprTermsDeniedOverlay ref="denyOverlay"  @denyTerms="onDenyTerms" @showTerms="onShowTerms"></GdprTermsDeniedOverlay>	
		</span>

		<BrowserNotice ref="browserNotice" />
	</div>
</template>

<script src="./BasePage.js"></script>
